import { COHORTS, useCohort, useLoggedOut } from '@/components/user-context/helpers/cohorts';

import { CrossflowEligibleUser } from './logged-in/crossflow-eligible-user';
import { CurrentProductUser } from './logged-in/current-product-user';
import { ExistingUser } from './logged-in/existing-user';
import { NewUser } from './logged-in/new-user';
import { UpliftEligibleUser } from './logged-in/uplift-eligible-user';
import { LoggedOut } from './logged-out/logged-out';

export const TeamworkCollectionSignup = () => {
	const cohort = useCohort();
	const loggedOut = useLoggedOut();

	if (loggedOut) {
		return <LoggedOut />;
	}

	if (!cohort) {
		return null;
	}

	switch (cohort) {
		case COHORTS.MANAGED_USER:
		case COHORTS.WEEK_ONE_USER:
		case COHORTS.CURRENT_PRODUCT_USER:
			return <CurrentProductUser />;

		case COHORTS.CROSSFLOW_ELIGIBLE_USER:
			return <CrossflowEligibleUser />;

		case COHORTS.UPLIFT_ELIGIBLE_USER:
			return <UpliftEligibleUser />;

		case COHORTS.NEW_USER:
			return <NewUser />;
		default:
			return <ExistingUser />;
	}
};
